import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20of%20floating%20geometric%20product%20showcase%20elements%20in%20soft%20cream%20and%20sage%20green%20tones%2C%20elegant%20minimal%20curved%20shapes%20with%20subtle%20texture%2C%20warm%20gradient%20lighting%2C%20airy%20Scandinavian%20gallery%20aesthetic%2C%20clean%20modern%20design%2C%20no%20text%2C%20no%20people%2C%20editorial%20quality%2C%20soft%20diffused%20shadows&width=1600&height=900&seq=hero-vigorbuy-main-2026&orientation=landscape"
          alt="Vigorbuy Spreadsheet product showcase"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-2xl">
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight">
              Vigorbuy Spreadsheet
              <span className="block font-heading italic font-normal text-primary-300 mt-2">
                The Ultimate Trusted Product Directory
              </span>
            </h1>

            <p className="mt-6 text-base md:text-lg text-background-200 leading-relaxed max-w-xl">
              Discover verified products, trusted sellers, QC guides, shipping tutorials, and the latest Vigorbuy Spreadsheet updates — all in one place.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-start gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Open Spreadsheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-background-50/40 text-background-50 rounded-full text-base font-semibold hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-shopping-bag-line"></i>
              </a>
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-4 md:gap-6">
              <span className="inline-flex items-center gap-1.5 text-sm text-background-200">
                <i className="ri-checkbox-circle-fill text-primary-400 text-base"></i>
                Verified Products
              </span>
              <span className="inline-flex items-center gap-1.5 text-sm text-background-200">
                <i className="ri-checkbox-circle-fill text-primary-400 text-base"></i>
                QC Checked
              </span>
              <span className="inline-flex items-center gap-1.5 text-sm text-background-200">
                <i className="ri-checkbox-circle-fill text-primary-400 text-base"></i>
                Trusted Sellers
              </span>
              <span className="inline-flex items-center gap-1.5 text-sm text-background-200">
                <i className="ri-checkbox-circle-fill text-primary-400 text-base"></i>
                Updated Daily
              </span>
            </div>

            <div className="mt-8">
              <Link
                to="/guide/vigorbuy-spreadsheet-guide"
                className="inline-flex items-center gap-2 text-sm font-medium text-primary-300 hover:text-primary-200 transition-colors duration-200 group"
              >
                Read the full Vigorbuy Spreadsheet guide
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}